/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import AttributeValues from "model/stats/AttributeValues";

class Attributes {
    static attributes: (keyof AttributeValues)[] = ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'];
    static STR = 0;
    static DEX = 1;
    static CON = 2;
    static INT = 3;
    static WIS = 4;
    static CHA = 5;
    
    static getAttrName = (name: string): keyof AttributeValues | '' => {
        for (const attr of Attributes.attributes) {
            if (attr.toLowerCase().startsWith(name.toLowerCase())) {
                return attr;
            }
        }
        return '';
    }

    static getBonus = (attrLevel: number): number => {
        return attrLevel ? Math.floor((attrLevel - 10)/2) : NaN;
    }
}

export default Attributes;